// List of font classes available in fonts.css
export const fonts = {
  display: 'display',
  h1: 'h1',
  h2: 'h2',
  caption: 'caption',
  inputLabel: 'inputLabel',
  paragraph1: 'paragraph1',
  paragraph2: 'paragraph2',
  paragraph3: 'paragraph3',
  button: 'button',
  support: 'support',
  link: 'link',
  faqHeading: 'faqHeading',
};
